import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { PropTypes } from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import {
  Grid,
} from '@mui/material';
import {
  RecentlyViewed,
  FavoritesList,
  UnresolvedNotesTable,
} from 'components';
import { LocationsUtil, StringUtil, withIsMobile } from 'utils';

const styles = (theme) => ({
  container: {
    padding: theme.spacing(3),
  },
});

class DashboardPage extends React.Component {
  render() {
    const { classes, isMobile } = this.props;

    // const missedData = StoreUtil.getData(missedMedications);
    const colSize = this.props.isMobile ? 12 : 4;

    return (
      <>
        <Helmet defer={false}>
          <title>Doctivity Dashboard</title>
        </Helmet>
        <div
          className={classes.container}
          style={{ marginLeft: !isMobile ? 128 : 0 }}
        >
          <Grid container spacing={3}>
            <Grid item xs={colSize}>
              <RecentlyViewed
                model='Providers'
                userId={this.props.user.id}
                name={StringUtil.providerName}
              />
            </Grid>
            <Grid item xs={colSize}>
              <RecentlyViewed
                model='Organizations'
                userId={this.props.user.id}
              />
            </Grid>
            <Grid item xs={colSize}>
              <RecentlyViewed
                model='Contacts'
                userId={this.props.user.id}
                name={StringUtil.providerName}
              />
            </Grid>

            <Grid item xs={colSize}>
              <FavoritesList
                objectType='Providers'
                name={StringUtil.providerName}
              />
            </Grid>
            <Grid item xs={colSize}>
              <FavoritesList objectType='Organizations' />
            </Grid>
            <Grid item xs={colSize}>
              <FavoritesList
                objectType='Contacts'
                name={StringUtil.providerName}
              />
            </Grid>
            <Grid item xs={colSize}>
              <FavoritesList
                objectType='Locations'
                name={LocationsUtil.formatNameOrAddress}
              />
            </Grid>

            <Grid item xs={12}>
              <UnresolvedNotesTable />
            </Grid>
          </Grid>
        </div>
      </>
    );
  }
}

DashboardPage.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  app: PropTypes.object,
  user: PropTypes.object,
};

function mapStateToProps(state) {
  const {
    app,
    user,
  } = state;

  return {
    app,
    user,
  };
}

const styled = withStyles(styles)(withIsMobile(DashboardPage));
const connected = connect(mapStateToProps)(styled);
export { connected as DashboardPage };
